<template>
  <section class="product-gallery">
    <div class="product-gallery__wrapper">
      <ul class="product-gallery__items">
        <CatalogProduct
          v-for="product in products"
          :key="product.id"
          :product="product"
        />
      </ul>
      <Pagination
        :current-page="params.page"
        :pages="getPages()"
        @on-page-change="onPageChange"
        @on-load-more="onLoadMore"
      />
    </div>
    <FooterDescription
      v-if="
        undefined !== category &&
        undefined !== getCategoryContent(category, 'description')
      "
      :content="getCategoryContent(category, 'description')"
    />
  </section>
</template>

<script setup>
import CatalogProduct from "~/modules/shared/productCard/CatalogProduct.vue";
import { useCategoriesStore } from "~/store/categoriesStore";
import { trackEvent } from "~/utils/trackEvent";
import FooterDescription from "~/modules/productCatalog/ui/components/FooterDescription.vue";
import Pagination from "~/modules/shared/pagination/Pagination.vue";
import { Category } from "~/models/category.model";
import { Product } from "~/models/product.model";
import { useProductStore } from "~/store/productStore";
import { useFilterStore } from "~/store/filterStore";

const props = defineProps({
  products: { type: Array, required: false, default: null },
  totalItems: { type: Number, required: false },
  category: { type: [Category, undefined], required: false },
});

const categoriesStore = useCategoriesStore();
const { getCategoryContent } = storeToRefs(categoriesStore);
const { params, setPage } = useFilterStore();
const { getMoreProducts } = useProductStore();

watch(
  props.products,
  () => {
    if (import.meta.client && null !== props.products) {
      const items = props.products.map((product, index) => {
        return {
          item_name: product.slug,
          item_id: product.code,
          price: product.getPrice(Product.PRICE_TYPE.CURRENT),
          item_brand: product.manufacturer.name,
          item_category: product.getMainCategory(),
          item_list_name: props.category?.getName(),
          index: index + 1,
          quantity: 1,
        };
      });

      const event = {
        event: "view_item_list",
        ecommerce: {
          items,
        },
      };

      // Add view catalog to google-analytics
      trackEvent(event);
    }
  },
  { immediate: true },
);

const getPages = () => {
  return Math.ceil(props.totalItems / params.limit);
};

const onPageChange = (page) => {
  setPage(page);
};

const onLoadMore = async (page) => {
  await getMoreProducts(page);
};
</script>

<style lang="scss" scoped>
.product-gallery {
  width: 100%;

  &__wrapper {
    @include flex-container(column, flex-start);

    gap: 64px;
    margin-bottom: 64px;
  }

  &__items {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(288px, 1fr));
    gap: 8px;

    @include mobile {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
